import React, { useState } from "react";
import { LoadingButton } from "../../../../Components/header/form";
import { toastMessage } from "../../../../utils/toastMessage";
import CustomModal from "../../../../Components/modals/CustomModal";
import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import "./Payment.css";

// const PaymentForm = ({ plainDetails, loading, setLoading, setPaymentModal, detailPageRefresh = () => { } }) => {
//     const stripe = useStripe();
//     const elements = useElements();

//     // const onSubmit = async (event) => {
//     //     event.preventDefault();

//     //     if (!stripe || !elements) {
//     //         console.log("Stripe.js has not loaded.");
//     //         return;
//     //     }
//     //     try {
//     //         setLoading(true)
//     //         const result = await stripe.confirmPayment({
//     //             elements,
//     //             // confirmParams: {
//     //             //     return_url: "http://localhost:3000/#/dashboard/group",
//     //             // },
//     //         });

//     //         if (result.error) {
//     //             // Handle specific error from Stripe
//     //             console.log("Payment Error:", result.error.message);
//     //         } else {
//     //             // Payment succeeded, handle success
//     //             console.log("Payment successful!");
//     //         }
//     //     } catch (error) {
//     //         // Catch unexpected errors
//     //         console.error("An unexpected error occurred:", error.message);
//     //     } finally {
//     //         setLoading(false)
//     //     }
//     // };

//     const onSubmit = async (event) => {
//         event.preventDefault();

//         if (!stripe || !elements) {
//             console.log("Stripe.js has not loaded.");
//             toastMessage("Payment processing is unavailable. Please try again later.", "error", "stripe_error");
//             return;
//         }
//         try {
//             setLoading(true);
//             const result = await stripe.confirmPayment({
//                 elements,
//             });

//             if (result.error) {
//                 toastMessage(result.error.message, "error", "payment_error");
//             } else {
//                 setPaymentModal(false);
//                 detailPageRefresh()
//                 toastMessage("Payment completed successfully!", "success", "payment_success");
//             }
//         } catch (error) {
//             console.log('error catch', error)
//             toastMessage("An unexpected error occurred. Please try again.", "error", "unexpected_error");
//         } finally {
//             setLoading(false);
//         }
//     };
//     return (
//         <div className="payment-container">
//             <h2 className="mb-3">Complete Payment</h2>
//             <PaymentElement />
//             <LoadingButton
//                 isDisabled={!stripe}
//                 onClick={onSubmit}
//                 loading={loading}
//             >
//                 Pay Now - {plainDetails?.currency} {plainDetails?.price}
//             </LoadingButton>
//         </div>
//     );
// };

const Payment = ({
  paymentModal,
  setPaymentModal,
  subscriptionDetails,
  plainDetails,
  listing,
  setPage, setHasMore, type
}) => {
  const stripeKey = process.env.REACT_APP_STRIPE_KEY || "";
  const stripePromise = loadStripe(stripeKey);

  const options = {
    clientSecret: subscriptionDetails?.paymentIntentClientSecret || "",
  };

  return (
    <CustomModal
      show={paymentModal}
      handleClose={() => setPaymentModal(false)}
      className="payment_modal"
    >
      <h2 className="mb-3">Complete Payment</h2>
      <Elements stripe={stripePromise} options={{ hidePostalCode: true }}>
        <CheckoutForm
          clientSecret={options.clientSecret}
          plainDetails={plainDetails}
          setPaymentModal={setPaymentModal}
          detailPageRefresh={listing}
          //------------------
          setPage={setPage}
          setHasMore={setHasMore}
          type={type}
        />
      </Elements>

      {/* {stripeKey && options.clientSecret ? (
                <Elements stripe={stripePromise} options={options}>
                    <PaymentForm
                        plainDetails={plainDetails}
                        setPaymentModal={setPaymentModal}
                        loading={loading} setLoading={setLoading} detailPageRefresh={listing} />
                </Elements>
            ) : (
                <p>Loading payment details...</p>
            )} */}
    </CustomModal>
  );
};

export default Payment;
